import { useCallback, useEffect, useState } from 'react';

import { useSessionStorage } from 'hb-react/shared/hooks/useSessionStorage';

interface UseOnlyOncePerSessionProps {
  enabled: boolean;
  id: string;
}

export interface UseOnlyOncePerSession {
  hasBeenSeen: boolean;
  markAsSeen: () => void;
}

export const useOnlyOncePerSession = ({
  enabled,
  id,
}: UseOnlyOncePerSessionProps): UseOnlyOncePerSession => {
  const sessionStorage = useSessionStorage();
  const key = `only-once-per-session-${id}`;

  const [hasBeenSeen, setHasBeenSeen] = useState(
    () => !!sessionStorage.get(key),
  );

  const markAsSeen = useCallback(() => {
    if (!hasBeenSeen) {
      if (sessionStorage.set(key, true)) {
        setHasBeenSeen(true);
      }
    }
  }, [hasBeenSeen, key, sessionStorage]);

  useEffect(() => {
    if (enabled && !hasBeenSeen) {
      markAsSeen();
    }
  }, [enabled, hasBeenSeen, markAsSeen]);

  return {
    hasBeenSeen,
    markAsSeen,
  };
};
